'use client';
import React, { useEffect, useState } from 'react';
import { IoIosSearch } from 'react-icons/io';
import { apiURL } from '../common/urls';
import PFLink from './PFLink';
import * as stylex from '@stylexjs/stylex';
import { colors } from '@/common/tokens.stylex';

export function SearchInput() {
  const [liveQuery, setLiveQuery] = useState('');
  const [sugesstions, setSugesstions] = useState<[] | null>(null);

  useEffect(() => {
    if (!liveQuery) return;
    const controller = new AbortController();
    const { signal } = controller;

    const debounce = setTimeout(() => {
      fetch(`${apiURL}/tag-suggestions?term=${liveQuery}`, {
        signal,
      })
        .then((res) => res.json())
        .then((json) => {
          setSugesstions(json);
        })
        .catch((err) => {
          setSugesstions(null);
        });
    }, 200);
    return () => {
      clearTimeout(debounce);
      controller.abort();
    };
  }, [liveQuery]);

  return (
    <>
      <div {...stylex.props(styles.row)}>
        <form
          role="search"
          method="get"
          action="/suche/"
          {...stylex.props(styles.form)}
        >
          <input
            onChange={(event) => setLiveQuery(event.target.value)}
            value={liveQuery}
            autoFocus
            itemProp="query-input"
            type="text"
            placeholder="Suchbegriff"
            name="q"
            {...stylex.props(styles.input)}
          />
          <button type="submit" {...stylex.props(styles.submit)}>
            <IoIosSearch size={24} {...stylex.props(styles.searchIcon)} />
          </button>
        </form>
      </div>
      {sugesstions && sugesstions.length > 0 && (
        <>
          <div {...stylex.props(styles.hint)}>Meinst du</div>
          <ul>
            {sugesstions.map((item) => (
              <li key={item.slug} {...stylex.props(styles.suggestion)}>
                <PFLink href={`/suche/?q=${item.name}`}>{item.name}</PFLink>
              </li>
            ))}
          </ul>
        </>
      )}
    </>
  );
}

const styles = stylex.create({
  row: {
    display: 'flex',
    margin: 20,
  },
  form: {
    display: 'flex',
    flexGrow: 1,
  },
  input: {
    caretColor: colors.primaryColor,
    borderTopLeftRadius: 12,
    borderBottomLeftRadius: 12,
    fontSize: 19,
    fontWeight: 500,
    color: colors.darkGrey,
    flexGrow: 1,
    height: 44,
    borderStyle: 'solid',
    borderWidth: 2,
    borderRightWidth: 1,
    borderColor: colors.primaryColor,
    padding: 8,
    zIndex: 1,
    ':focus': {
      outline: 'none',
      boxShadow: '0 0 0 2px #FFB3d1',
      borderColor: '#FFB3d1',
    },
    '::placeholder': {
      color: colors.placeholderTextColor,
    },
  },
  submit: {
    borderTopRightRadius: 12,
    borderBottomRightRadius: 12,
    cursor: 'pointer',
    height: 44,
    width: 44,
    borderStyle: 'none',
    backgroundColor: colors.tintColor,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  searchIcon: {
    color: colors.white,
  },
  hint: {
    textAlign: 'center',
    color: {
      default: colors.darkGrey,
      ['@media (prefers-color-scheme: dark)']: colors.white,
    },
    fontWeight: 700,
  },
  suggestion: {
    textAlign: 'center',
    margin: 20,
  },
});
